import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const BREAKPOINT = 1240,
			CLASSNAME = 'open'

export default class GHeader {
	constructor(header) {
		header = header || document.querySelector('#gheader')
		if (!header) return

		this.header = header
		this.nav = header.querySelector('nav')
		this.toggle = header.querySelector('._toggle')
		this.accordionBtns = header.querySelectorAll('.gnav-lv1 > li.menu-item-has-children > a')

		if (this.toggle) this.toggle.onclick = this.toggleNav.bind(this)
		if (this.accordionBtns.length > 0) {
			this.accordionBtns.forEach(btn => {
				btn.onclick = this.lv1BtnClicked.bind(this)
			})
		}
	}

	toggleNav() {
		this.toggle.classList.toggle('close')
		this.nav.classList.toggle(CLASSNAME)
		if (this.nav.classList.contains(CLASSNAME)) this.openNav()
		else this.closeNav()
	}

	openNav() {
		document.documentElement.style.overflow = 'hidden'
		disableBodyScroll(this.nav)
	}

	closeNav() {
		document.documentElement.style.overflow = null
		enableBodyScroll(this.nav)
	}

	openAccordion(accordion) {
		let h = accordion.scrollHeight
		accordion.style.maxHeight = h + 'px'
	}

	closeAccordion(accordion) {
		accordion.style.maxHeight = null
	}

	lv1BtnClicked(e) {
		if (window.innerWidth >= BREAKPOINT) return
		e.preventDefault()
		let btn = e.currentTarget,
				accordion = btn.nextElementSibling
		btn.classList.toggle(CLASSNAME)
		if (accordion.style.maxHeight) this.closeAccordion(accordion)
		else this.openAccordion(accordion)
	}
}
